import { useQuery } from '@tanstack/react-query';
import { fetchDefaultSemester, fetchFullSchedule, fetchScheduleByDate } from '../api/scheduleApi';
import { makeFullSchedule } from '../mappers/fullScheduleMapper';

export const DEFAULT_SEMESTER_KEY = 'defaultSemester';
export const FULL_SCHEDULE_KEY = 'fullSchedule';
export const SCHEDULE_BY_DATE_KEY = 'scheduleByDate';

export const useDefaultSemester = () =>
    useQuery({
        queryKey: [DEFAULT_SEMESTER_KEY],
        queryFn: fetchDefaultSemester,
    });

export const useFullSchedule = (semesterId) =>
    useQuery({
        queryKey: [FULL_SCHEDULE_KEY, semesterId],
        queryFn: () => fetchFullSchedule(semesterId),
        enabled: !!semesterId,
        select: (data) => {
            if (data?.published === false) {
                return { notPublished: true, message: data.message };
            }
            return { schedule: makeFullSchedule(data), notPublished: false };
        },
    });

// The grid an exam session sits on: which dates it runs, and which periods and groups it uses.
// Asked of the server rather than worked out here, so that the rule for which days a session
// covers lives in one place.
export const useScheduleByDate = (semesterId) =>
    useQuery({
        queryKey: [SCHEDULE_BY_DATE_KEY, semesterId],
        queryFn: () => fetchScheduleByDate(semesterId),
        enabled: !!semesterId,
    });
